var styleDataHash = '3993ab4b';  
export const injectCss = (() => {
  var css = `._7X7U7{min-height:28px;padding-inline-end:var(--ricos-custom-footer-toolbar-padding-inline-end,0);padding-inline-start:var(--ricos-custom-footer-toolbar-padding-inline-start,0);width:100%;z-index:2}[dir] ._7X7U7{margin-top:var(--ricos-custom-footer-toolbar-margin-top,60px)}._7X7U7 svg{fill:var(--ricos-custom-footer-toolbar-icon-color,var(--ricos-text-color));color:var(--ricos-custom-footer-toolbar-icon-color,var(--ricos-text-color))}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "footerToolbar": "_7X7U7"
};